module.exports = __webpack_public_path__ + "static/media/ic_delete_successful.3a32dcec.svg";